import { node, string } from "prop-types";
import React from "react";

// Opens in a new tab so the Test UI keeps its selected user and form state.
function CampaignLink({ campaignId, label }) {
  if (!campaignId) return null;

  return (
    <a
      href={`#/campaigns/${campaignId}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {label || campaignId}
    </a>
  );
}

CampaignLink.propTypes = {
  campaignId: string,
  label: node,
};

export default CampaignLink;
